//
import { ModuleLayout } from '@/components/reusable_components/next'
import {
    PrevisionCreate,
    PrevisionDetail,
    PrevisionList,
} from '@/views/HumanResource/HrPrevision'

/**
 *
 */
export default {
    path: 'previsions',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'prevision-list',
            component: PrevisionList,
        },
        {
            path: 'new',
            name: 'prevision-create',
            component: PrevisionCreate,
        },
        {
            path: ':id',
            name: 'prevision-detail',
            component: PrevisionDetail,
        },
    ],
    meta: {
        title: 'AFPs',
    },
}
